
import { Injectable } from '@angular/core';
import { VoucherModel } from './models/voucher.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  constructor(private http: HttpClient) { }

  getVoucherList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/vouchers/get', requestData);

  }

  getVoucherById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/vouchers/get/'+id, '');

  }

   /**
   *
   * @param voucherInfo
   * Calls the update API to insert/update the record
   */
   update(voucherInfo: VoucherModel): Observable<any> {
    if(voucherInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/vouchers/update', voucherInfo);
    } else{
      return this.http.post(environment.baseUrl+'/vouchers/add', voucherInfo);
    }
  }


    /**
   *
   * @param voucherInfo
   * Calls the API to delete the record
   */
    delete(voucherInfo: VoucherModel): Observable<any>  {
      // alert();
      return this.http.post(environment.baseUrl+'/vouchers/delete/'+voucherInfo.id, voucherInfo);
    }

    downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
     // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

      return this.http.post(environment.baseUrl + '/vouchers/export-voucher-list', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }

}
